var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifetimeAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.074,
    height: 12.897,
    viewBox: "0 0 31.074 12.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artificial_intelegence",
    "data-name": "artificial intelegence",
    transform: "translate(-2 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M26.859,7a7.032,7.032,0,0,0-3.838,1.126l-5.485,3.69-5.531-3.69A7.255,7.255,0,0,0,5.5,7.572,5.2,5.2,0,0,0,2,12.179v2.59a5.216,5.216,0,0,0,3.525,4.567,7.254,7.254,0,0,0,6.481-.566l5.531-3.638,5.531,3.69a7.255,7.255,0,0,0,6.508.554,5.2,5.2,0,0,0,3.5-4.607v-2.59C33.074,9.319,30.292,7,26.859,7Zm-16.8,9.8a3.633,3.633,0,0,1-3.222.242,2.6,2.6,0,0,1-1.735-2.275v-2.59A2.6,2.6,0,0,1,6.842,9.9a3.633,3.633,0,0,1,3.222.242l4.987,3.328Zm19.9-2.033A2.619,2.619,0,0,1,28.205,17a3.633,3.633,0,0,1-3.195-.255l-4.987-3.276,4.987-3.328A3.633,3.633,0,0,1,28.232,9.9a2.6,2.6,0,0,1,1.735,2.275Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifetimeAccess);
export default __webpack_public_path__ + "static/media/lifetime-access.c2ccbbc0a247ff03c69fce6a9b7200ad.svg";
export { ForwardRef as ReactComponent };